import { removeSpaces } from "shared/core/utils/string";
import helplineNumbersJson from "shared/assets/json/helplineNumbers.json";

type HelplineNumber = { country: string; number: string };

const helplineNumbers: HelplineNumber[] = helplineNumbersJson;

const parseHelplineNumbers = (inputString: string): HelplineNumber[] => {
  const parsedNumbers: HelplineNumber[] = [];
  const normalizedInput = removeSpaces(inputString);

  for (const { number, country } of helplineNumbers) {
    const normalizedNumber = removeSpaces(number);
    const regex = new RegExp(normalizedNumber, "g");

    if (regex.test(normalizedInput)) {
      const alreadyExists = !!parsedNumbers.find((data) => data.number === number);
      !alreadyExists && parsedNumbers.push({ country, number });
    }
  }

  return parsedNumbers;
};

export default parseHelplineNumbers;
